import { API_ORIGIN } from "../Utils";

/** Copy text to clipboard — matches formats-dashboard fallback for non-secure contexts. */
export async function copyTextToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return true;  
  }

  const el = document.createElement("textarea");
  el.value = text;
  el.style.position = "fixed";
  el.style.opacity = "0";
  document.body.appendChild(el);
  el.focus();
  el.select();

  try {
    document.execCommand("copy");
    return true;
  } catch {
    return false;
  } finally {
    document.body.removeChild(el);
  }
}

/** Fetch partner referral link (same POST pattern as formats-dashboard copy-link). */
export async function fetchPartnerReferralLink() {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("No access token");

  const res = await fetch(`${API_ORIGIN}/partners/api/partners/copy-link/`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) throw new Error("Failed to fetch referral link");
  return res.json();
}

/** Fetch link from API and copy to clipboard — mirrors formats-dashboard Refer button. */
export async function copyPartnerReferralLink() {
  const data = await fetchPartnerReferralLink();
  const link = data?.referral_link;
  if (!link) throw new Error("No referral link");

  const copied = await copyTextToClipboard(link);
  if (!copied) throw new Error("Copy failed");

  return link;
}
